import Icon from '@klv/atoms/icon';
import * as styles from './styles/features-list.module.css';
import type { IPricingCardFeaturesList } from '../types';

export const FeaturesListItem = ({ listIcon, listText }: IPricingCardFeaturesList) => {
  return (
    <div className={styles.featuresList}>
      {listIcon === 'checkmark' ? (
        <Icon className={styles.checkmark} iconName="CheckMarkBullet" />
      ) : (
        <Icon className={styles.xmark} iconName="XMarkBullet" />
      )}
      <div className={styles.listText}>{listText}</div>
    </div>
  );
};
